import React, { FC, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';
import { CurrencySelect } from 'shared/components/CurrencySelect/CurrencySelect';
import commonStyles from 'shared/components/CurrencySelect/CurrencySelect.module.scss';
import { palette } from 'shared/constants/colorsConstants';

const IndicatorComponent = () => (
  <div className={commonStyles.currencySelectIndicator}>
    <GenerateIcon iconName={ICONS.caretDown.name} />
  </div>
);

interface InnerSelectSelectProps {
  disabled: boolean;
  property: string;
  label: FC<any>;
  error?: string;
}

export const InnerSelectSelect: FC<InnerSelectSelectProps> = ({ disabled, property, label: Label, error = '' }) => {
  const { setValue, getValues } = useFormContext();
  const currencyContext = useCurrencyContext();
  const [selectedOption, setSelectedOption] = useState<string | null>('USD');
  useEffect(() => {
    if (disabled) {
      setSelectedOption(null);
      return;
    }
    const selected = getValues(property);
    setSelectedOption(selected);
  }, [getValues, property, disabled, getValues(property)]);

  const handleSelectCurrency = (currency: string) => {
    setSelectedOption(currency);
    setValue(property, currency, { shouldValidate: true });
  };

  return (
    <>
      <Label />
      <div className={commonStyles.currencySelect}>
        <CurrencySelect
          classes={commonStyles.standAloneSelect}
          disabled={disabled}
          selectedCurrency={selectedOption}
          currenciesArray={currencyContext.currenciesArray}
          setSelectedCurrency={handleSelectCurrency}
          indicatorComponent={() => <IndicatorComponent />}
          error={error}
          controlBackgroundColor={palette.gray[200]}
        />
      </div>
    </>
  );
};
